export default {
  BACKEND_URL: 'https://sspapi.noneho.com/api/public/articles/inbio',
};
